/**
 * 加载使用百度小程序JSSDK
 */
import LibLoader from '../base/lib-loader'

let lib: LibLoader

export function swanReady(callback: Function) {
  if (!lib) {
    lib = new LibLoader('lib-swan', 'https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.12.js')
  }
  lib.push(callback)
}
